/**
 * JWT `calendarPermissions` (audience `calendar-api`) for org holidays & org-wide events only.
 */

/** Any authenticated org member can list holidays (matches backend GET). */
export function canViewOrgHolidays(permissions: string[] | undefined): boolean {
  void permissions;
  return true;
}

/** Any authenticated org member can list company events (matches backend GET). */
export function canViewOrgWideEvents(permissions: string[] | undefined): boolean {
  void permissions;
  return true;
}

export function hasOrgHolidayPermission(
  permissions: string[] | undefined,
  action: 'create' | 'update' | 'delete'
): boolean {
  return Boolean(permissions?.includes(`calendar:holidays.${action}`));
}

export function hasOrgWideEventPermission(
  permissions: string[] | undefined,
  action: 'create' | 'update' | 'delete'
): boolean {
  return Boolean(permissions?.includes(`calendar:org_events.${action}`));
}
